<p-confirmDialog key="geofencealerts" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<div class="DateFlex">
		<label>Start Date:</label>
		<p-calendar
			class="SmallFlex"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="StartDate"
			name="StartDate"
			(ngModelChange)="onStartDateChange($event)"
		></p-calendar>

		<label class="LargeFlex">End Date:</label>
		<p-calendar
			class="SmallFlex"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="EndDate"
			name="EndDate"
			(ngModelChange)="onEndDateChange($event)"
		></p-calendar>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onActivate()">Activate Alerts</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onDeactivate()">Deactivate Alerts</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstGeoFenceAlertTxn"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedGeoFenceAlertTxns"
		dataKey="GeoFenceAlertTxnID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--BusNbr-->
				<th>
					<p-columnFilter type="text" field="BusNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--GeoFenceDesc-->
				<th>
					<p-columnFilter field="GeoFenceDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterGeoFenceDesc
								[ngModel]="value"
								[options]="lstGeoFenceDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--GeofenceTriggerTypeDesc-->
				<th>
					<p-columnFilter field="GeofenceTriggerTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterGeofenceTriggerTypeDesc
								[ngModel]="value"
								[options]="lstGeofenceTriggerTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--SeverityDesc-->
				<th>
					<p-columnFilter field="SeverityDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSeverityDesc
								[ngModel]="value"
								[options]="lstSeverityDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--AlertComments-->
				<th>
					<p-columnFilter type="text" field="AlertComments" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StartDT-->
				<th>
					<p-columnFilter type="text" field="StartDT" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--EndDT-->
				<th>
					<p-columnFilter type="text" field="EndDT" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="BusNbr">Bus<p-sortIcon field="BusNbr"></p-sortIcon></th>
				<th pSortableColumn="GeoFenceDesc">Geo Fence<p-sortIcon field="GeoFenceDesc"></p-sortIcon></th>
				<th pSortableColumn="GeofenceTriggerTypeDesc">Trigger Type<p-sortIcon field="GeofenceTriggerTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="SeverityDesc">Severity<p-sortIcon field="SeverityDesc"></p-sortIcon></th>
				<th pSortableColumn="AlertComments">Comments<p-sortIcon field="AlertComments"></p-sortIcon></th>
				<th pSortableColumn="StartDT">Start<p-sortIcon field="StartDT"></p-sortIcon></th>
				<th pSortableColumn="EndDT">End<p-sortIcon field="EndDT"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-GeoFenceAlertTxn>
			<tr [pSelectableRow]="GeoFenceAlertTxn" (dblclick)="onRowDblClick(GeoFenceAlertTxn)">
				<td>
					<p-tableCheckbox [pSelectableRow]="GeoFenceAlertTxn" [value]="GeoFenceAlertTxn"></p-tableCheckbox>
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ GeoFenceAlertTxn[col.field] }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="GeoFenceAlertTxn.Active == true ? 'Black' : 'Red'"
				>
					{{ GeoFenceAlertTxn["ActiveDesc"] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
